jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  // Home Form Section
  if ($("body.home").length) {
    // Mailchimp forms
    // ---
    $("form.mailchimp-form").each(function (index, el) {
      $(el).submit(function (e) {
        e.preventDefault();
        console.log("Forms Initialized");

        var $errors = $(el).next(".mailchimp-errors-or-success");
        $.ajax({
          type: "GET", // GET & url for json slightly different
          url: "https://starharboracademy.us7.list-manage.com/subscribe/post-json?c=?",
          data: $(el).serialize(),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          error: function (err) {
            console.log("Could not connect to the registration server.");
          },
          success: function (data) {
            console.log(data);

            if (data.result != "success") {
              console.log("Connected to MailChimp but something is wrong with the form");
              if (data.msg.indexOf("is already subscribed") >= 0) {
                var msg = "<p>This email address is already subscribed.</p>";
                $errors.empty();
                $errors.html(msg);
              }
              if (data.msg.indexOf("An email address must contain a single @") >= 0) {
                var msg = "<p>Please enter a valid email address.</p>";
                $errors.empty();
                $errors.html(msg);
              }
              console.log(data.msg);
            } else {
              $(el).hide();
              $(el).closest(".form-contain").find(".subscribe-notice").css({opacity: 0});
              $(el).next(".mailchimp-errors-or-success").addClass("success");
              var msgconfirm;
              msgconfirm = "<p class='success'>Thank you for subscribing to our updates. We look forward to sharing more about STAR HARBOR with you soon.</p>";
              $errors.html(msgconfirm);

              console.log("success");
            }
          },
        });
      });
    });
    // ---
    // END Mailchimp
  }
});
